import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import router from "@/router";
import MainLayout from "./layouts/MainLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose }) {
  expose();

const layout = computed(() => {
  return router.currentRoute.value.meta.layout || MainLayout;
});

const __returned__ = { layout, computed, router, MainLayout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})